import { useTranslation } from 'next-i18next';
import React, { useState, useEffect } from 'react';
import { useContextSelector } from 'use-context-selector';
import BrandsSelect from '@components/molecules/sell/brandSelect/brandSelect';
import CategoriesSelect from '@components/molecules/sell/categorySelect/categorySelect';
import ModelsSelect from '@components/molecules/sell/modelSelect/modelSelect';
import UniverseSelect from '@components/molecules/sell/universeSelect/universeSelect';
import { ListingContext } from '@context/listing.context';
import { usePreferences } from '@context/preferences.context';
import subCategories from './categories.json';
import styles from './index.module.scss';

interface SentencePartInterface {
  variant?: 'a' | 'b';
}

const SentencePart1: React.FC<SentencePartInterface> = (): React.JSX.Element => {
  const { t } = useTranslation('pricing-calculator');
  const { listingDraftPayload } = useContextSelector(ListingContext, (state) => state);
  const { language } = usePreferences();
  const selectedLanguage = language?.toUpperCase();
  const mappedCategories = subCategories[selectedLanguage] || subCategories.EN;
  const [isSubcatPlural, setIsSubcatPlural] = useState(mappedCategories[listingDraftPayload?.category]?.isPlural);

  useEffect(() => {
    setIsSubcatPlural(mappedCategories[listingDraftPayload?.category]?.isPlural);
  }, [listingDraftPayload?.category, mappedCategories]);

  return (
    <span className={styles.formSentence__text}>
      {`${
        isSubcatPlural
          ? t('PRICING_CALCULATOR.SENTENCE.PART_1.PLURAL')
          : t('PRICING_CALCULATOR.SENTENCE.PART_1.SINGULAR')
      } `}
    </span>
  );
};

const SentencePart2: React.FC<SentencePartInterface> = ({ variant }): React.JSX.Element => {
  const { t } = useTranslation('pricing-calculator');
  return (
    <span className={styles.formSentence__text}>{`${
      variant === 'a' ? t('PRICING_CALCULATOR.SENTENCE.PART_2.A') : t('PRICING_CALCULATOR.SENTENCE.PART_2.B')
    } `}</span>
  );
};

const FormSentence: React.FC = () => {
  const { listingDraftPayload } = useContextSelector(ListingContext, (state) => state);
  const { language } = usePreferences();
  const isSubcatPlural: boolean = false;

  /**
   * Set the sentence structure
   * may have a third structure with Korean, not defiend yet
   * */
  const sentencePattern: 1 | 2 = language === 'fr' || language === 'it' || language === 'es' ? 2 : 1;

  const getSelectFromSentencePlace = (sentencePlace): React.JSX.Element => {
    if ((sentencePattern === 2 && sentencePlace === 1) || (sentencePattern === 1 && sentencePlace === 2)) {
      return <CategoriesSelect />;
    }
    return <UniverseSelect />;
  };

  return (
    <form className={styles.formSentence}>
      <div>
        <SentencePart1 />
        {getSelectFromSentencePlace(1)}
      </div>
      <div>
        {(language === 'es' || language === 'it') && <SentencePart2 variant={'a'} />}
        {getSelectFromSentencePlace(2)}
        <SentencePart2 variant={'b'} />
        <BrandsSelect />
      </div>
      {listingDraftPayload.category !== '' && <ModelsSelect isSubcatPlural={isSubcatPlural} />}
    </form>
  );
};

export default FormSentence;
